import { createReducer } from 'redux-starter-kit';
import { selectRequest } from '../../domain/requests/RequestReducer';
import {
  fetchDashboardIssueData,
  fetchDashboardPageData,
  fetchDashboardRateData,
  fetchDashboardReasonData,
  setWidgets
} from './dashboardUiActions';


// INITIAL SELECT
export const selectDashboardPageDataRequest = (state) => {
  const requestId = state.via.ui.dashboardData.requestDashboardPageDataId;
  if (!requestId) return null;
  return selectRequest(state, requestId);
};

// Inspection Rate
export const selectDashboardRateDataRequest = (state) => {
  const requestId = state.via.ui.dashboardData.requestDashboardRateDataId;
  if (!requestId) return null;
  return selectRequest(state, requestId);
};

// Inspection Reasons
export const selectDashboardReasonDataRequest = (state) => {
  const requestId = state.via.ui.dashboardData.requestDashboardReasonDataId;
  if (!requestId) return null;
  return selectRequest(state, requestId);
};

// Inspection Issues
export const selectDashboardIssueDataRequest = (state) => {
  const requestId = state.via.ui.dashboardData.requestDashboardIssueDataId;
  if (!requestId) return null;
  return selectRequest(state, requestId);
};

// Get current widgets
export const selectCurrentWidgets = (state) => {
  const left = state.via.ui.dashboardData.widgetLeft;
  const right = state.via.ui.dashboardData.widgetRight;
  const option1 = state.via.ui.dashboardData.optionRates;
  const option2 = state.via.ui.dashboardData.optionReasons;
  const option3 = state.via.ui.dashboardData.optionIssues;
  return [left, right, option1, option2, option3];
};

const dashboardInitialState = {
  requestDashboardPageDataId: null,
  requestDashboardRateDataId: null,
  requestDashboardReasonDataId: null,
  requestDashboardIssueDataId: null,
  widgetLeft: 1,
  widgetRight: 1,
  optionRates: 7,
  optionReasons: 7,
  optionIssues: 7,
};

// REDUCER
const dashboardReducer = createReducer(dashboardInitialState, {
  [fetchDashboardPageData]: (state, action) => ({
    ...state,
    requestDashboardPageDataId: action.payload,
  }),
  [fetchDashboardRateData]: (state, action) => ({
    ...state,
    requestDashboardRateDataId: action.payload,
  }),
  [fetchDashboardReasonData]: (state, action) => ({
    ...state,
    requestDashboardReasonDataId: action.payload,
  }),
  [fetchDashboardIssueData]: (state, action) => ({
    ...state,
    requestDashboardIssueDataId: action.payload,
  }),
  [setWidgets]: (state, action) => ({
    ...state,
    widgetLeft: action.payload[0],
    widgetRight: action.payload[1],
    optionRates: action.payload[2],
    optionReasons: action.payload[3],
    optionIssues: action.payload[4],
  }),
});

export default dashboardReducer;
